(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["group_image"] && !Shopify.designMode) return;
  try {
    
  /* Add your JavaScript code here */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-refine-copy"]) return;
  try {
    
  document.querySelectorAll('a[href="#susbtitutedata"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById('susbtitutedata');
      if (target) {
        // Key fix: Use 'start' alignment + inline block-start
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start', // Top of element
          inline: 'start', // Left edge (prevent horizontal shift)
        });
      }
    });
  });
  document.addEventListener('DOMContentLoaded', function() {
  const eyeIcon = document.querySelector('.eyepriceicon');
  const tooltip = eyeIcon.querySelector('.tooltip-text-hover');

  // Toggle tooltip on click
  eyeIcon.addEventListener('click', function(e) {
    e.stopPropagation(); // prevent click from bubbling
    tooltip.classList.toggle('show'); // toggle visibility
  });

  // Hide tooltip when clicking outside
  document.addEventListener('click', function() {
    tooltip.classList.remove('show');
  });
});

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".wehreto").forEach(btn => {
    btn.addEventListener("click", function() {
      const modal = document.querySelector(".modal_find");
      if (modal) {
        modal.style.display = "block"; // directly show modal
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-refinment"]) return;
  try {
    
  document.querySelectorAll('a[href="#susbtitutedata"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById('susbtitutedata');
      if (target) {
        // Key fix: Use 'start' alignment + inline block-start
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start', // Top of element
          inline: 'start', // Left edge (prevent horizontal shift)
        });
      }
    });
  });
  document.addEventListener('DOMContentLoaded', function() {
  const eyeIcon = document.querySelector('.eyepriceicon');
  const tooltip = eyeIcon.querySelector('.tooltip-text-hover');

  // Toggle tooltip on click
  eyeIcon.addEventListener('click', function(e) {
    e.stopPropagation(); // prevent click from bubbling
    tooltip.classList.toggle('show'); // toggle visibility
  });

  // Hide tooltip when clicking outside
  document.addEventListener('click', function() {
    tooltip.classList.remove('show');
  });
});

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".wehreto").forEach(btn => {
    btn.addEventListener("click", function() {
      const modal = document.querySelector(".modal_find");
      if (modal) {
        modal.style.display = "block"; // directly show modal
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('a[href="#susbtitutedata"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById('susbtitutedata');
      if (target) {
        // Key fix: Use 'start' alignment + inline block-start
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start', // Top of element
          inline: 'start', // Left edge (prevent horizontal shift)
        });
      }
    });
  });
  document.addEventListener('DOMContentLoaded', function() {
  const eyeIcon = document.querySelector('.eyepriceicon');
  const tooltip = eyeIcon.querySelector('.tooltip-text-hover');

  // Toggle tooltip on click
  eyeIcon.addEventListener('click', function(e) {
    e.stopPropagation(); // prevent click from bubbling
    tooltip.classList.toggle('show'); // toggle visibility
  });

  // Hide tooltip when clicking outside
  document.addEventListener('click', function() {
    tooltip.classList.remove('show');
  });
});

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".wehreto").forEach(btn => {
    btn.addEventListener("click", function() {
      const modal = document.querySelector(".modal_find");
      if (modal) {
        modal.style.display = "block"; // directly show modal
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new_main-product"]) return;
  try {
    
  document.querySelectorAll('a[href="#susbtitutedata"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById('susbtitutedata');
      if (target) {
        // Key fix: Use 'start' alignment + inline block-start
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start', // Top of element
          inline: 'start', // Left edge (prevent horizontal shift)
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
